import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const mouse = useRef({ x: -100, y: -100 });
  const ringPos = useRef({ x: -100, y: -100 });
  const rafId = useRef(null);

  useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX - 4}px, ${e.clientY - 4}px)`;
      }
    };

    const onDown = () => ringRef.current?.classList.add("is-hover");
    const onUp = () => ringRef.current?.classList.remove("is-hover");

    const handleHoverIn = () => ringRef.current?.classList.add("is-hover");
    const handleHoverOut = () => ringRef.current?.classList.remove("is-hover");

    const attachHover = () => {
      document.querySelectorAll("a, button, input, textarea, [data-cursor-hover]")
        .forEach((el) => {
          el.addEventListener("mouseenter", handleHoverIn);
          el.addEventListener("mouseleave", handleHoverOut);
        });
    };

    const loop = () => {
      const { x, y } = mouse.current;
      ringPos.current.x += (x - ringPos.current.x) * 0.18;
      ringPos.current.y += (y - ringPos.current.y) * 0.18;
      if (ringRef.current) {
        const rx = ringPos.current.x - 20;
        const ry = ringPos.current.y - 20;
        ringRef.current.style.transform = `translate(${rx}px, ${ry}px)`;
      }
      rafId.current = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);
    attachHover();
    rafId.current = requestAnimationFrame(loop);

    // Re-attach when DOM updates
    const observer = new MutationObserver(attachHover);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
      cancelAnimationFrame(rafId.current);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={ringRef} className="cursor-ring" data-testid="custom-cursor-ring" />
      <div ref={dotRef} className="cursor-dot" data-testid="custom-cursor-dot" />
    </>
  );
}
